/**
 * @file 例外處理服務
 * @description 提供統一的錯誤處理與日誌記錄功能
 */

/** 日誌等級常數 */
export const LEVEL = {
  INFO: 'INFO',
  WARRING: 'WARRING',
  ERROR: 'ERROR'
} as const;

/** 日誌等級型別 */
export type LogLevel = (typeof LEVEL)[keyof typeof LEVEL];

/** 例外處理服務配置介面 */
export interface ExceptionHandleServiceConfig {
  _NAME?: string;
  _NOTICE?: string;
}

/**
 * 例外處理服務類別
 * @class ExceptionHandleService
 * @description 統一處理應用程式的例外狀況，提供日誌記錄功能
 */
class ExceptionHandleService {
  _NAME: string;
  _NOTICE: string | null;
  _LEVEL = LEVEL;

  constructor({ _NAME, _NOTICE }: ExceptionHandleServiceConfig) {
    this._NAME = _NAME ? _NAME : 'unknown';
    this._NOTICE = _NOTICE ? _NOTICE : null;
  }

  logger(level: LogLevel, msg: string): void {
    switch (level) {
      case LEVEL.INFO:
        console.info(msg);
        break;
      case LEVEL.WARRING:
        console.warn(msg);
        break;
      case LEVEL.ERROR:
        console.error(msg);
        console.log('=== error', msg);
        break;
      default:
        console.log(msg);
    }
  }

  /**
   * error 統一處理簡易 middleware
   */
  errorReport(error: unknown, cusMsg: string, level: LogLevel): void {
    console.log('=== errorReport');
    console.log('=== error', error);
    console.log('=== cusMsg', cusMsg);
    console.log('=== level', level);

    this.logger(
      level,
      `>${this._NAME}<
[NOTICE]: ${this._NOTICE}
[訊息]: ${cusMsg}
${error}`
    );
  }
}

export default ExceptionHandleService;
